

const FilterDetails = {
    "phaseDetails": {
        "1": {
            "title": 'Single Phase',
            "img": '/img/genus-configurator/icon_singlephase.svg'
        },
        "3": {
            "title": 'Three Phase',
            "img": '/img/genus-configurator/icon_threephase.svg'
        }
    },
    "hzDetails":{
        "60": {
            "title": '60 Hz',
            "img": '/img/genus-configurator/icon_60hz.svg'
        },
        "50": {
            "title": '50 Hz',
            "img": '/img/genus-configurator/icon_50hz.svg'
        },
    },
    "voltageDetails": {
        "115": {
            "title": '115 volt',
            "img": '/img/genus-configurator/icon_115volt.svg'
        },
        "208-240": {
            "title": '208 volt - 240 volt',
            "img": '/img/genus-configurator/icon_208volt.svg'
        },
        "220-240": {
            "title": '220 volt - 240 volt',
            "img": '/img/genus-configurator/icon_220volt.svg'
        },
        "380-415": {
            "title": '380 volt - 415 volt',
            "img": '/img/genus-configurator/icon_380volt.svg'
        },
        "460": {
            "title": '460 volt',
            "img": "https://embed.widencdn.net/img/vollrath/fav1xxlu75/exact/SFS_460_Voltage.jpeg?position=c&crop=no&color=ffffffff&u=3zcdxz"
        }
    },
    "coolingDetails": {
        "Air": {
            "title": 'Air Cooled',
            "img": '/img/genus-configurator/icon_aircooled.svg?v=2025-06-03.4'
        },
        "Water": {
            "title": 'Water Cooled',
            "img": '/img/genus-configurator/icon_watercooled.svg?v=2025-06-03'
        },
        "Air Remote": {
            "title": 'Air Cooled - Remote',
            "img": '/img/genus-configurator/icon_airremote.svg?v=2025-06-03'
        }
    }

}

export default FilterDetails;
